import { ColumnDetails, ColumnType } from '../types/common';
import { translateFn } from '../../utils/translator.helper';

export function getLabelForEnumValue<Column extends number, ColumnKeys extends string>(
  columnDetails: ColumnDetails<Column, ColumnKeys>,
  value: number
): string {
  if (![ColumnType.ENUM, ColumnType.SELECT, ColumnType.EDITABLE_SELECT].includes(columnDetails.type)) {
    throw new Error('Programmatic Error: unexpectedly called getLabelForEnumValue for non-enum value');
  }
  // For enums, we need to show the mapped label for the value.
  const matchedValues = (columnDetails.values || []).filter(enumValue => enumValue.value === value);
  if (matchedValues.length !== 1) {
    console.error(`Unexpected ENUM value for column with key ${columnDetails.key}: ${value}`);
    return translateFn('Unknown');
  }
  return matchedValues[0].label;
}
